require('./seminar-detail.less');
let slickDefaults = require('../slick-default/slick-default');
let styleSelects = require('../styled-select/styled-select');
let size = require('../../modules/size');
$(function() {
    const timeItems = $('.timeItems');
    styleSelects.styleSelects($('.js-styled-select'));
    var $selectTime = $('.js-styled-select', timeItems);
    $selectTime && styleSelects.styleSelects($selectTime);

    const pageSeminar = $('.pageSeminar.active');
    const pageSeminarFooter = $('.formRegistrFooter');
    let seminarId = parseInt(pageSeminar.data('seminar')) | 0;
    if (seminarId) {
        window.seminarEntryPage(seminarId, pageSeminar.data('date'), pageSeminar.data('city'), pageSeminar.data('time'), pageSeminar.data('place'), pageSeminar.data('isfree'));
    }

    $('.workshop-item__date select').on('change', function (e) {
        $('.workshop__btn a').removeClass('active');
        $('.workshop-item__btn a').removeClass('active');
        $('.pageSeminar').removeClass('active');
        $('.workshop-item__prices .workshop-item__price-value').removeClass('active');

        let optionSelected = $("option:selected", this);
        let valueSelected = optionSelected.attr('data-id');

        $('.workshop-item__price-value[data-id="' + valueSelected + '"]').addClass('active');
        $('.pageSeminar[data-id="' + valueSelected + '"]').addClass('active');
        $('.workshop__btn a[data-id="' + valueSelected + '"]').addClass('active');
        $('.workshop-item__btn a[data-id="' + valueSelected + '"]').addClass('active');

        const pageSeminarChange = $('.pageSeminar.active');
        let seminarIdChange = parseInt(pageSeminarChange.data('seminar')) | 0;
        window.seminarEntryPage(seminarIdChange, pageSeminarChange.data('date'), pageSeminarChange.data('city'), pageSeminarChange.data('time'), pageSeminarChange.data('place'), pageSeminarChange.data('isfree'));
    });
    // Обработка при клике на кнопку записи на семинар
    $(document).on('click', '.seminar_block_name', function(event) {
        event.preventDefault();
        $('.block-description_detail-text ul[data-name="' + $(this).attr('data-name') + '"]').toggle();
    });
    $(document).on('click', '.js-seminar-entry', function(event) {
        var $this = $(this);
        if ($this.attr('href')) {
            return;
        }

        event.preventDefault();

        // Если не установлен адрес перехода по ссылке семинара, то отображаем форму записи на семинар
        if (!window.seminarEntry) {
            throw new Error('Ошибка вызова окна записи на семинар. На странице не подключен метод "seminarEntry".');
        }

        var seminar = parseInt($this.data('seminar')) | 0;
        if (seminar) {
            window.seminarEntry(seminar, $this.data('date'), $this.data('city'), $this.data('time'), $this.data('place'), $this.data('isfree'));
        }
    });

    $(document).on('click', '.js-seminar-consultation-entry', function(event) {
        var $this = $(this);
        if ($this.attr('href')) {
            return;
        }

        event.preventDefault();

        // Если не установлен адрес перехода по ссылке семинара, то отображаем форму записи на семинар
        if (!window.seminarConsultationEntry) {
            throw new Error('Ошибка вызова окна записи на семинар. На странице не подключен метод "seminarEntry".');
        }

        var seminar = parseInt($this.data('seminar')) | 0;
        if (seminar) {
            window.seminarConsultationEntry(seminar, $this.data('date'), $this.data('city'), $this.data('time'), $this.data('place'), $this.data('isfree'));
        }
    });

    $('.reviews__body--news').each(function() {
        var $brandsSlider = $(this);

        $brandsSlider.slick(
            $.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
                slidesToShow: 3,
                dots: true,
                responsive: [
                    {
                        breakpoint: size.desktop,
                        settings: { slidesToShow: 3 }
                    },
                    {
                        breakpoint: size.tabletBig,
                        settings: { slidesToShow: 2 }
                    },
                    {
                        breakpoint: size.tablet,
                        settings: { slidesToShow: 2 }
                    },
                    {
                        breakpoint: size.mobileBig,
                        settings: { slidesToShow: 1 }
                    }
                ]
            })
        );
    });
});



// WEBPACK FOOTER //
// ./blocks/seminar-detail/seminar-detail.js